var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLayers48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9897 26.0265L3.37221 17.0323L0.820312 19.0083L14.9975 29.9864L29.1747 19.0083L26.6071 17.0244L14.9897 26.0265Z",
    fill: "#F64B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9975 21.8851L26.5992 12.9405L29.1747 10.9484L14.9975 0.0117188L0.820312 10.9484L3.38796 12.9248L14.9975 21.8851Z",
    fill: "#F64B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLayers48Px);
export default __webpack_public_path__ + "static/media/ic_layers_48px.8aa8bbf1b390f7faddd6f7fa03ff12ff.svg";
export { ForwardRef as ReactComponent };